import { useEffect, useState } from "react";
import { IpData, getIp } from "../remote/scan_data"
import { useNavigate } from "react-router-dom";
import { Button, CircularProgress, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

export interface IPProps {
	id: string
	data?: IpData
	hideChildren?: boolean
}

export const IPSimple = ({id, data = undefined}: IPProps) => {
	const navigate = useNavigate()

	const [ipData, setIpData] = useState<IpData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getIp(id, (data, resp) => {
				if (data) {
					setIpData(data);
				} else {
					setIpData(null);
				}
			});
		}
	}, [setIpData]);

	return (ipData
		? <Stack direction='row'><Button onClick={() => navigate(`/tree/ip/${id}`)}>
			<Typography variant="body1" sx={{wordBreak:'break-all', overflowWrap:'break-word'}}>{ipData.ip}</Typography>
		</Button></Stack>
		: <CircularProgress />
	)
}

export const IP = ({id, data = undefined, hideChildren = false}: IPProps) => {
	const navigate = useNavigate()

	const [ipData, setIpData] = useState<IpData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getIp(id, (data, resp) => {
				if (data) {
					setIpData(data);
				} else {
					setIpData(null);
				}
			});
		}
	}, [setIpData]);

	return (ipData
		? 	<TableContainer component={Paper}>
			<Table width={hideChildren ? 'auto' : '100%'}>
				<TableHead>
					<TableRow>
						<TableCell>
							<Typography variant="h5">IP</Typography>
						</TableCell>
						<TableCell align='right'>
							{hideChildren ? (<></>) :
							(ipData.children.length > 0 ?
							<Button onClick={() => navigate(`/tree/ip/${id}`)}>See children</Button>
							: <Button disabled>No children</Button>)}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
				<TableRow><TableCell align='left'>IP</TableCell><TableCell align='right'>{ipData.ip}</TableCell></TableRow>
				<TableRow><TableCell align='left'>First seen</TableCell><TableCell align='right'>{String(ipData.first_seen)}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Last seen</TableCell><TableCell align='right'>{String(ipData.last_seen)}</TableCell></TableRow>
				</TableBody>
			</Table>
			</TableContainer>
		: <CircularProgress />
	)
}
